export default {
  PARAMETER: 'preview',
  EXPECTED_VALUE: 'true'
};



// WEBPACK FOOTER //
// ./src/constants/ContentfulPreview.js